<ng-container>
  <ng-container>
    <button
      mat-icon-button
      data-automation-id="smt-action-button-clear-filters"
      (click)="clearFilters()"
      [attr.aria-label]="'ALDEN.ACTIONS.CLEAR_FILTERS' | translate"
      [attr.title]="'ALDEN.ACTIONS.CLEAR_FILTERS' | translate"
    >
      <mat-icon>delete_sweep</mat-icon>
    </button>
  </ng-container>
</ng-container>

<ng-template>
  <span>{{ 'ALDEN.ACTIONS.CLEAR_FILTERS' | translate }}</span>
</ng-template>
